import { Box, Tooltip, useMediaQuery, useTheme } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'store';
import Avatar from 'ui-component/extended/Avatar';
import { getContrastYIQ, isHebrewString } from 'utils/helpers';

interface UserAssigneeProps {
  assigneeId: string | null;
  assigneeName: string | null;
  assigneColor: string | null;
}
const UserAssignee: React.FC<UserAssigneeProps> = ({ assigneeId, assigneeName, assigneColor }) => {
  const assignee = useSelector((state) => state.applicationUsers.find((user) => user.Udid === assigneeId));
  // אם לא מצאנו את המשתמש ב-applicationUsers, נשתמש ב-assigneeName ישירות מהשרת
  const displayName = assignee?.FullName || assigneeName;
  const theme = useTheme();
  const matchesMobile = useMediaQuery(theme.breakpoints.down(480));

  return (
    <Tooltip title={displayName || ''} arrow>
      {matchesMobile ? (
        <span>
          {displayName && (
            <Avatar
              sx={{
                width: '18px !important',
                height: '18px !important',
                fontSize: '11px !important',
                bgcolor: assigneColor || '#7C7C7C',

                WebkitTransition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',

                [theme.breakpoints.down(480)]: {
                  width: '28px !important',
                  height: '28px !important',
                  fontSize: '16px !important',
                },
              }}
            >
              {displayName &&
                displayName.split(' ').length > 0 &&
                `${displayName?.split(' ')[0].slice(0, 1)}${
                  displayName.split(' ')[1] ? displayName.split(' ')[1].slice(0, 1) : ''
                }`}
            </Avatar>
          )}
        </span>
      ) : (
        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            maxWidth: '100%',
            borderRadius: 0.75,
            px: 0.75,
            transitionProperty: 'color, background-color, border-color',
            transitionDuration: '150ms',
            transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
            transitionDelay: '0ms',

            //* Colors
            backgroundColor: displayName ? assigneColor || '#7C7C7C' : 'transparent',
            color: displayName ? getContrastYIQ(assigneColor ? assigneColor : '#7C7C7C') : assigneColor,
            border: `1px solid ${assigneColor || '#7C7C7C'}`,
          }}
        >
          <Box
            component="span"
            sx={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              direction: !isHebrewString(displayName || '') ? 'rtl' : 'ltr',
              fontSize: 10,
              maxWidth: '100%',
            }}
          >
            {displayName ? displayName : <FormattedMessage id="chat.single-chat-user.not-assigned" />}
          </Box>
        </Box>
      )}
    </Tooltip>
  );
};

export default UserAssignee;
